import Subject from "../cse4sub/Subject";
import React from 'react'
import csm from '../assets/ASH101mid21.pdf'
import cse from '../assets/ASH101end21.pdf'

export default function Ep() {
  return (
    <div>
       <Subject title="Engineering Physics(ASH101)"mid="Q. Paper"
    book1="An Introduction to Mechanics — D Kleppner & R Kolenkow" book2=" "
    book1Link="https://bayanbox.ir/view/7764531208313247331/Kleppner-D.-Kolenkow-R.J.-Introduction-to-Mechanics-2014.pdf" 
    book2Link="#" int21="#" mid21={csm} end21={cse}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}